<form
    #downloadForm
    action="{{ _url }}"
    method="POST"
    onsubmit="event.preventDefault()"
    enctype="application/x-www-form-urlencoded"
    style="top: 0; left: 0; width: 1px; height: 1px; position: absolute; visibility: hidden"
>
    @for (item of _paramsKeys; track item) {
        <div>
            @if (!item.isArray) {
                <input
                    type="hidden"
                    value="{{ _params[item.key] }}"
                    [id]="item.key"
                    [name]="item.key"
                />
            }
            @if (item.isArray) {
                @for (arrEntry of _params[item.key]; track arrEntry) {
                    <input type="hidden" value="{{ arrEntry }}" [id]="arrEntry" [name]="item.key" />
                }
            }
        </div>
    }
</form>
